import React from 'react';
import { StyleSheet, Text, View} from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
    footer: {
        backgroundColor: '#223e4a',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: 595.28,
        height: 40
    },
    footerview: {
        flexDirection: 'row',
        width: 595.28,
    },
    footerclient : {
        textAlign: 'left',
        color: '#ffffff',
        fontSize: 8,
        fontFamily: 'TTNorms',
        fontWeight: 'normal',
        paddingTop: '8px',
        paddingLeft: '20px',
        width: 450,
    },
    footerclient2 : {
        textAlign: 'left',
        color: '#ffffff',
        fontSize: 8,
        fontFamily: 'TTNorms',
        fontWeight: 'normal',
        paddingTop: '2px',
        paddingLeft: '20px',
        width: 450,
    },
    footerpagenum: {
        textAlign: 'right',
        paddingTop: '8px',
        paddingRight: '20px',
        color: '#ffffff',
        fontSize: 8,
        fontFamily: 'TTNorms',
        fontWeight: 'normal',
        width: 145.28,
    },
    footerdate: {
        textAlign: 'right',
        paddingTop: '2px',
        paddingRight: '20px',
        color: '#ffffff',
        fontSize: 8,
        fontFamily: 'TTNorms',
        fontWeight: 'normal',
        width: 145.28,
    }

});

class Footer extends React.Component {

    render() {
        // console.log(this.props.form);
        return(
            <View style={styles.footer} fixed>
                <View style={styles.footerview}>
                    <Text style={styles.footerclient}>
                        Document prepared for: {this.props.form.firstname} {this.props.form.lastname}
                    </Text>
                    {/*<Text style={styles.ftxt}>Document created on: 30th April 2020</Text>*/}
                    <Text style={styles.footerpagenum} render={({pageNumber, totalPages}) => (
                        `Page ${pageNumber} of ${totalPages}`
                    )} fixed/>
                </View>
                <View style={styles.footerview}>
                    <Text style={styles.footerclient2}>
                        email: {this.props.form.email} | phone: {this.props.form.phone}
                    </Text>
                    <Text style={styles.footerdate}>Report prepared on {new Intl.DateTimeFormat('en-GB').format(Date.now())}</Text>
                </View>
            </View>
        )
    }
};

export default Footer;
